export default "__VITE_ASSET__US3nc3Kl__"